import { NAVBAR_ID } from '../constants';

let animationFrameId: number;

export function scrollNavbarToTop() {
  let currentOffset = 0;

  const step = () => {
    const offsetY = window.visualViewport ? window.visualViewport.offsetTop : 0;

    if (offsetY !== currentOffset) {
      const navbar = document.getElementById(NAVBAR_ID);

      if (navbar) {
        navbar.style.transition = 'transform .2s';
        navbar.style.transform = `translateY(${offsetY}px)`;

        currentOffset = offsetY;
      }
    }

    animationFrameId = window.requestAnimationFrame(step);
  };

  animationFrameId = window.requestAnimationFrame(step);
}

export function resetNavbarPosition() {
  const navbar = document.getElementById(NAVBAR_ID);

  if (navbar) {
    navbar.style.transform = 'translateY(0)';
  }

  window.cancelAnimationFrame(animationFrameId);
}
